// Profile actions
export const SET_USER_PROFILE = "profile/SET_USER_PROFILE";
export const GET_USER_PROFILE = "profile/GET_USER_PROFILE";
export const UPDATE_USER_PROFILE = "profile/SET_USER_PROFILE";
export const TOGGLE_EDIT_MODE = "profile/TOGGLE_EDIT_MODE";

//Credit card
export const SET_CREDIT_CARD = "profile/SET_CREDIT_CARD";
